import { render, staticRenderFns } from "./LpuAccessibilityGallery.vue?vue&type=template&id=ebfbb5fe&scoped=true&"
import script from "./LpuAccessibilityGallery.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuAccessibilityGallery.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuAccessibilityGallery.vue?vue&type=style&index=0&id=ebfbb5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfbb5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebfbb5fe')) {
      api.createRecord('ebfbb5fe', component.options)
    } else {
      api.reload('ebfbb5fe', component.options)
    }
    module.hot.accept("./LpuAccessibilityGallery.vue?vue&type=template&id=ebfbb5fe&scoped=true&", function () {
      api.rerender('ebfbb5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuAccessibilityGallery/LpuAccessibilityGallery.vue"
export default component.exports